import { render, staticRenderFns } from "./PackageTabs.vue?vue&type=template&id=ee2cbca2&scoped=true&"
import script from "./PackageTabs.vue?vue&type=script&lang=js&"
export * from "./PackageTabs.vue?vue&type=script&lang=js&"
import style0 from "./PackageTabs.vue?vue&type=style&index=0&id=ee2cbca2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2cbca2",
  null
  
)

export default component.exports